import { useQuery } from "@tanstack/react-query";
import { fetchUserOrderItems } from "../services/order-services";

function useUserOrders(user, pageSize, pageNumber) {
  const { data: userOrderItems, isLoading } = useQuery({
    queryKey: ["user-orders", pageSize, pageNumber],
    queryFn: () =>
      fetchUserOrderItems(
        {
          accessToken: user?.accessToken,
        },
        pageSize,
        pageNumber
      ),
    enabled: !!user?.accessToken,
  });

  return {
    userOrderItems: userOrderItems?.data?.data,
    isLoading,
  };
}

export default useUserOrders;